// Single source of truth for the v3 course/programme cover frame (860px content width x 240px height);
// applied to the banner via [style.aspect-ratio] and to the crop dialog via aspectRatio.
export const V3_COVER_ASPECT_RATIO = 860 / 240;

export const V3_COVER_RESIZE_TO_WIDTH = 1720;

export const IMAGE_UPLOAD_DIALOG_CONFIG = {
  width: '47rem',
  height: '80vh',
  maxHeight: '80vh',
  position: {
    top: '10vh',
  },
  restoreFocus: true,
  panelClass: ['ptl-mat-dialog', 'image-upload-unsplash-dialog'],
  backdropClass: 'dialog-backdrop',
  data: {},
};

export const IMAGE_UPLOAD_DIALOG_CONFIG_MOBILE = {
  width: '100vw',
  height: '100vh',
  maxWidth: '100vw',
  maxHeight: '100vh',
  position: { top: '0', left: '0' },
  restoreFocus: true,
  panelClass: ['ptl-mat-dialog', 'image-upload-unsplash-dialog', 'mobile-fullscreen-dialog'],
  backdropClass: 'dialog-backdrop',
  data: {},
};

export const AUDIO_UPLOAD_DIALOG_CONFIG = {
  width: '47rem',
  height: '35rem',
  maxHeight: '80vh',
  position: { top: '10vh' },
  restoreFocus: true,
  panelClass: 'ptl-mat-dialog',
  backdropClass: 'dialog-backdrop',
  data: {},
};

export const AUDIO_UPLOAD_DIALOG_CONFIG_MOBILE = {
  width: '100vw',
  height: '100vh',
  maxWidth: '100vw',
  maxHeight: '100vh',
  position: { top: '0', left: '0' },
  restoreFocus: true,
  panelClass: ['ptl-mat-dialog', 'mobile-fullscreen-dialog'],
  backdropClass: 'dialog-backdrop',
  data: {},
};

export const LINK_PREVIEW_DIALOG_CONFIG = {
  width: '36rem',
  position: { top: '10vh' },
  restoreFocus: true,
  panelClass: ['ptl-mat-dialog', 'add-link-editor-dialog'],
  backdropClass: 'dialog-backdrop',
  data: {},
};

export const LINK_PREVIEW_DIALOG_CONFIG_MOBILE = {
  width: '100vw',
  height: '100vh',
  maxWidth: '100vw',
  maxHeight: '100vh',
  position: { top: '0', left: '0' },
  restoreFocus: true,
  panelClass: ['ptl-mat-dialog', 'add-link-editor-dialog', 'mobile-fullscreen-dialog'],
  backdropClass: 'dialog-backdrop',
  data: {},
};

export const INLINE_LINK_DIALOG_CONFIG = {
  width: '34rem',
  maxHeight: '80vh',
  position: { top: '10vh' },
  restoreFocus: true,
  panelClass: ['ptl-mat-dialog', 'inline-link-dialog'],
  backdropClass: 'dialog-backdrop',
  data: {},
};

export const INLINE_LINK_DIALOG_CONFIG_MOBILE = {
  width: '100vw',
  height: '100vh',
  maxWidth: '100vw',
  maxHeight: '100vh',
  position: { top: '0', left: '0' },
  restoreFocus: true,
  panelClass: ['ptl-mat-dialog', 'inline-link-dialog', 'mobile-fullscreen-dialog'],
  backdropClass: 'dialog-backdrop',
  data: {},
};

export const STREAM_VIDEO_UPLOAD_DIALOG_CONFIG = {
  width: '47rem',
  height: '35rem',
  maxHeight: '80vh',
  position: { top: '10vh' },
  restoreFocus: true,
  panelClass: 'ptl-mat-dialog',
  backdropClass: 'dialog-backdrop',
  data: {},
};

export const STREAM_VIDEO_UPLOAD_DIALOG_CONFIG_MOBILE = {
  width: '100vw',
  height: '100vh',
  maxWidth: '100vw',
  maxHeight: '100vh',
  position: { top: '0', left: '0' },
  restoreFocus: true,
  panelClass: ['ptl-mat-dialog', 'mobile-fullscreen-dialog'],
  backdropClass: 'dialog-backdrop',
  data: {},
};

export const DOCUMENT_UPLOAD_DIALOG_CONFIG = {
  width: '47rem',
  height: '35rem',
  maxHeight: '80vh',
  position: { top: '10vh' },
  restoreFocus: true,
  panelClass: 'ptl-mat-dialog',
  backdropClass: 'dialog-backdrop',
  data: {},
};

export const DOCUMENT_UPLOAD_DIALOG_CONFIG_MOBILE = {
  width: '100vw',
  height: '100vh',
  maxWidth: '100vw',
  maxHeight: '100vh',
  position: { top: '0', left: '0' },
  restoreFocus: true,
  panelClass: ['ptl-mat-dialog', 'mobile-fullscreen-dialog'],
  backdropClass: 'dialog-backdrop',
  data: {},
};

export const PREVIEW_DIALOG_CONFIG = {
  width: '90vw',
  maxWidth: '75rem',
  height: '90vh',
  maxHeight: '90vh',
  position: { top: '5vh' },
  restoreFocus: true,
  panelClass: 'ptl-mat-dialog',
  backdropClass: 'dialog-backdrop',
  data: {},
};

export const PREVIEW_DIALOG_CONFIG_MOBILE = {
  width: '100vw',
  height: '100vh',
  maxWidth: '100vw',
  maxHeight: '100vh',
  position: { top: '0', left: '0' },
  restoreFocus: true,
  panelClass: ['ptl-mat-dialog', 'mobile-fullscreen-dialog'],
  backdropClass: 'dialog-backdrop',
  data: {},
};

export const IMAGE_LINK_DIALOG_CONFIG = {
  width: '34rem',
  maxHeight: '80vh',
  position: { top: '10vh' },
  restoreFocus: true,
  panelClass: ['ptl-mat-dialog', 'image-link-dialog'],
  backdropClass: 'dialog-backdrop',
  data: {},
};

export const IMAGE_LINK_DIALOG_CONFIG_MOBILE = {
  width: '100vw',
  height: '100vh',
  maxWidth: '100vw',
  maxHeight: '100vh',
  position: { top: '0', left: '0' },
  restoreFocus: true,
  panelClass: ['ptl-mat-dialog', 'image-link-dialog', 'mobile-fullscreen-dialog'],
  data: {},
};

export const IMAGE_CAPTION_DIALOG_CONFIG = {
  width: '34rem',
  maxHeight: '80vh',
  position: { top: '10vh' },
  restoreFocus: true,
  panelClass: ['ptl-mat-dialog', 'image-caption-dialog'],
  backdropClass: 'dialog-backdrop',
  data: {},
};

export const IMAGE_CAPTION_DIALOG_CONFIG_MOBILE = {
  width: '100vw',
  height: '100vh',
  maxWidth: '100vw',
  maxHeight: '100vh',
  position: { top: '0', left: '0' },
  restoreFocus: true,
  panelClass: ['ptl-mat-dialog', 'image-caption-dialog', 'mobile-fullscreen-dialog'],
  backdropClass: 'dialog-backdrop',
  data: {},
};
